import { gql } from '@apollo/client';

export default gql`
  mutation setClientState(
    $leftPanelWidth: Int
    $selectedPage: String
    $sideMenu: String
    $modalTypeShown: String
    $numberOfColumns: Int
    $selectedPlanNodeId: String
    $selectedSubContentIndex: Int
    $selectedIntroContentIndex: Int
    $pageType: String
    $generalSettingsCurrentTab: String
    $checked: [String]
    $showPreviewLinks: Boolean
    $syncSelectAllDropdown: Boolean
    $sidebarMask: Boolean
    $deviceView: String
  ) {
    setClientState(
      leftPanelWidth: $leftPanelWidth
      selectedPage: $selectedPage
      sideMenu: $sideMenu
      modalTypeShown: $modalTypeShown
      numberOfColumns: $numberOfColumns
      selectedPlanNodeId: $selectedPlanNodeId
      selectedSubContentIndex: $selectedSubContentIndex
      selectedIntroContentIndex: $selectedIntroContentIndex
      pageType: $pageType
      generalSettingsCurrentTab: $generalSettingsCurrentTab
      checked: $checked
      showPreviewLinks: $showPreviewLinks
      syncSelectAllDropdown: $syncSelectAllDropdown
      sidebarMask: $sidebarMask
      deviceView: $deviceView
    ) @client
  }
`; 